import { useCallback, useMemo } from 'react';

import moment from 'moment';

import { DATE_FORMAT_FOR_PARSE } from './DatePicker.constants';

export const useDatePickerPresenter = ({
  onChange,
  onBlur: onBlurProp,
  outputFormat,
  value: valueProp,
}) => {
  const value = useMemo(() => {
    const parsed = moment(valueProp, outputFormat);

    if (!parsed.isValid()) {
      return '';
    }

    return parsed.format(DATE_FORMAT_FOR_PARSE);
  }, [valueProp, outputFormat]);

  const onBlur = useCallback(
    (event) => {
      if (!event) {
        return;
      }

      let entries = [[undefined, event]];

      if (typeof event === 'object' && event) {
        entries = Object.entries(event);
      }

      const [[key, value]] = entries;

      const parsed = moment(value, DATE_FORMAT_FOR_PARSE);

      if (!parsed.isValid()) {
        return;
      }

      const formatted = parsed.format(outputFormat);
      const payload = key ? { [key]: formatted } : formatted;

      onBlurProp(payload);
      onChange(payload);
    },
    [outputFormat, onBlurProp, onChange]
  );

  return { onBlur, value };
};
